import React from 'react'

import { useCurrentSurveyGroupIdState } from '~/hooks/useCurrentSurveyGroupIdState'

import { useMainQuerySurveyGroups } from './useMainQuery'

export const useCurrentSurveyGroup = () => {
  const surveyGroups = useMainQuerySurveyGroups()
  const [surveyGroupId] = useCurrentSurveyGroupIdState()

  return React.useMemo(
    () =>
      surveyGroups.find((surveyGroup) => surveyGroup.id === surveyGroupId) ??
      surveyGroups[0],
    [surveyGroupId, surveyGroups],
  )
}
